import { useState } from 'react'
import CnAutomationPage from './cn-automation.page'
import CnAutomationLoginPage from './cn-automation-login.page'
import { isCnAutomationAuthenticated } from './cn-automation-auth'

const CnAutomationRoute = () => {
  const [authed, setAuthed] = useState(isCnAutomationAuthenticated)

  if (!authed) {
    return <CnAutomationLoginPage onSuccess={() => setAuthed(true)} />
  }

  return <CnAutomationPage />
}

export default CnAutomationRoute
